import { apiRequest } from '@/Groups/Scanner/private/imports/sharedUtils';

const BASE = '/api/screener/widgets';

export const apiGetWidgetTopLocalLow = (limit = 6) =>
  apiRequest(`${BASE}/top-local-low/?limit=${limit}`);